

















import { Vue, Component } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import OnboardingMeetingSchedulingHubspotIframe, {
  IHubspotForm
} from '@/componentsV2/templates/OnboardingMeetingSchedulingHubspotIframe/OnboardingMeetingSchedulingHubspotIframe.vue';
import getFirstName from '@/utils/get-first-name';

@Component({
  components: {
    Typography,
    FilledButton,
    OnboardingMeetingSchedulingHubspotIframe
  }
})
export default class ScheduleOnboardingIframe extends Vue {
  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get manager() {
    return this.businessInfo.manager;
  }

  get rescheduleLink() {
    return this.businessInfo.onboardingMeeting.rescheduleLink;
  }

  get params() {
    const firstName = getFirstName(this.manager.fullname) as string;
    const lastName = this.manager.fullname.replace(`${firstName} `, '');

    const params: IHubspotForm = {
      firstName,
      lastName,
      email: this.manager.mail,
      company: this.businessInfo.name
    };

    return params;
  }

  handleConfim() {
    window.close();
  }
}
